import { useQuery, UseQueryOptions } from 'react-query';
import { Notes } from 'src/graphql/schema.graphql';
import { APIs } from 'src/models/apis';
import { useAPIs } from 'src/hooks/useAPIs';
import { QueryKey } from 'src/models/query';
import { userNotesGqlQuery } from 'src/modules/user/graphql/user-notes.query';
import { NeauviaItem } from 'src/models/directus';
import { useUserPermissions } from 'src/modules/user/hooks/useUserPermissions';

export const fetchUserNotes = async (apis: APIs, itemId: string) => {
  const directus = await apis.directus();

  return directus
    .query(userNotesGqlQuery, {
      filters: {
        targetId: {
          _eq: itemId,
        },
      },
    })
    .then((a) => a.notes);
};

export const useUserNotesQuery = (
  item?: NeauviaItem | null,
  options?: Omit<
    UseQueryOptions<Notes[], unknown, Notes[], (string | undefined)[]>,
    'queryKey' | 'queryFn'
  >,
) => {
  const apis = useAPIs();
  const [userPermissions] = useUserPermissions();

  return useQuery(
    [...QueryKey.MaterialsUserNotes, item?.id],
    () => (item != null ? fetchUserNotes(apis, item.id) : []),
    { enabled: item != null && userPermissions.kol, ...options },
  );
};
